import { render, staticRenderFns } from "./ManageMemberCarPark.vue?vue&type=template&id=480e63d8&scoped=true"
import script from "./ManageMemberCarPark.vue?vue&type=script&lang=js"
export * from "./ManageMemberCarPark.vue?vue&type=script&lang=js"
import style0 from "./ManageMemberCarPark.vue?vue&type=style&index=0&id=480e63d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480e63d8",
  null
  
)

export default component.exports